import React, { useState } from "react";
import PropTypes from "prop-types";
import Popover from "react-popover";
import Truncate from "react-truncate"; // Import Truncate component
import "./titleSubtitleCard.scss";

/**
 *
 * @description
 * title : To display title
 * subtitle : To display subtitle
 * titleIcon : Icon to display beside title
 * subtitleIcon : Icon to display beside subtitle
 * subtitleRightIcon : Icon next to subtitle text
 * viewIcon : Icon next to the subtitleRightIcon
 *
 */

const TitleSubtitleCard = (props) => {
  const {
    handleViewDetails,
    disabled,
    titleStyle,
    title,
    titleIcon,
    customIcon,
    titleIconHoverText,
    uhId,
    subtitleIcon,
    handleIconClick,
    data,
    disableSubtitleIcon,
    subtitle,
    subtitleRightIcon,
    subtitleRightIconHoverText,
    viewIcon,
    displayHoverText,
    subtitleStyle = {},
  } = props;
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  // Actions ==>

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleMouseEnter = () => {
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    setShowPopup(false);
  };

  const handleViewDetailsClick = () => {
    handleViewDetails();
  };

  // <===

  // Create UI ==>

  const displayHoverContent = (iconHoverText) => {
    return (
      <div style={{ padding: "6px 10px", fontSize: "12px" }}>
        {iconHoverText}
      </div>
    );
  };

  const displayCardView = () => {
    return (
      <div
        className={`title-subtitle-card-container ${
          disabled ? "disable-card" : ""
        }`}
      >
        <div className="title-text overflow-guard" style={titleStyle}>
          {title}{" "}
          {(titleIcon || customIcon) && (
            <Popover
              isOpen={isOpen}
              preferPlace={`below`}
              place={null}
              anchorEl={anchorEl}
              body={displayHoverContent(titleIconHoverText)}
            >
              {props?.customIcon ? (
                <div
                  onMouseOver={handlePopoverOpen}
                  onMouseOut={handlePopoverClose}
                >
                  {titleIcon}
                </div>
              ) : (
                <img
                  src={titleIcon}
                  alt=""
                  style={{ cursor: "pointer", marginLeft: "6px" }}
                  onMouseOver={handlePopoverOpen}
                  onMouseOut={handlePopoverClose}
                />
              )}
            </Popover>
          )}
        </div>
        {uhId && <div>{uhId()}</div>}
        <div className="subtitle-text" style={subtitleStyle}>
          {subtitleIcon && (
            <img
              src={subtitleIcon}
              className={
                "subtitle-icon details " +
                (disableSubtitleIcon ? "subtitle-icon-disabled" : "")
              }
              alt=""
              onClick={() => !disableSubtitleIcon && handleIconClick(data)}
            />
          )}
          {subtitle}
          {subtitleRightIcon && (
            <Popover
              isOpen={isOpen}
              preferPlace={`below`}
              place={null}
              anchorEl={anchorEl}
              body={displayHoverContent(subtitleRightIconHoverText)}
            >
              <img
                src={subtitleRightIcon}
                className="subtitle-right-icon details"
                alt=""
                onMouseOver={handlePopoverOpen}
                onMouseOut={handlePopoverClose}
              />
            </Popover>
          )}
          {viewIcon && (
            <div className="purpose-of-consultation-icon-wrapper">
              <img
                src={viewIcon}
                alt="Click me"
                className="purpose-of-consultation-icon details"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
              {showPopup && (
                <div
                  className="purpose-of-consultation-popup-wrapper"
                  style={{
                    transform:
                      title.length < 5 ? "translate(-30%)" : "translate(-50%)",
                  }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="purpose-of-consultation-popup-content">
                    <Truncate
                      lines={2}
                      ellipsis={
                        <span>
                          ...
                          <span
                            className="show-more-arrow-icon"
                            onClick={handleViewDetailsClick}
                          >
                            {">"}
                          </span>
                        </span>
                      }
                    >
                      {displayHoverText}
                    </Truncate>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  // <===
  return <>{displayCardView()}</>;
};

TitleSubtitleCard.propTypes = {
  title: PropTypes.any.isRequired,
};

export default TitleSubtitleCard;
